module.exports = __webpack_public_path__ + "static/media/Figtree-BoldItalic.219abf85.ttf";